import { render, staticRenderFns } from "./NotificationRecipients.vue?vue&type=template&id=a9520fc8&scoped=true"
import script from "./NotificationRecipients.vue?vue&type=script&lang=js"
export * from "./NotificationRecipients.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipients.vue?vue&type=style&index=0&id=a9520fc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9520fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9520fc8')) {
      api.createRecord('a9520fc8', component.options)
    } else {
      api.reload('a9520fc8', component.options)
    }
    module.hot.accept("./NotificationRecipients.vue?vue&type=template&id=a9520fc8&scoped=true", function () {
      api.rerender('a9520fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/NotificationRecipients.vue"
export default component.exports